import { getMessages } from "../../../api/messages";
import { GET_MESSAGES } from "@constants/reactQueryKeys";
import { useQuery } from "react-query";

/**
 * Fetches all messages for a given outbound user.
 *
 * @param {number | string} outboundUserId - The ID of the outbound user.
 * @param {number | null} [pollingMs=null] - Optional polling interval in milliseconds.
 */
export const useGetMessages = (outboundUserId, pollingMs = null) => {
  const { data, isLoading, refetch } = useQuery(
    [GET_MESSAGES, outboundUserId],
    () => getMessages(outboundUserId),
    {
      enabled: !!outboundUserId,
      refetchInterval: pollingMs ?? false,
    }
  );

  return {
    messages: data?.data || null,
    messagesLoading: isLoading,
    refetchMessages: refetch,
  };
};
